import React from "react";
import { IHouse } from "../../interfaces/interfaces";
export const prepareMessageText = (messageText: string) => {
  const lines = messageText.split("\n");
  return (
    <>
      {lines.map((line, index) => {
        if (index !== lines.length - 1) {
          return (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          );
        }
        return <React.Fragment key={index}>{line}</React.Fragment>;
      })}
    </>
  );
};

export const calculateHousePrice = (house: IHouse, days?: number): number => {
  let total;

  if (typeof days === "number") {
    total = Math.round((days / 30) * parseInt(house.price!));
  } else {
    total = parseInt(house.price!);
  }

  // Check if additional_expenses is defined and numeric, then add it to the total
  if (
    house.additional_expenses &&
    !isNaN(parseInt(house.additional_expenses))
  ) {
    total += parseInt(house.additional_expenses);
  }

  // Check if service_costs is defined and numeric, and add it to the total
  if (house.service_costs && !isNaN(parseInt(house.service_costs))) {
    total += parseInt(house.service_costs);
  }

  return total;
};
